export default {
    id:null,
    name: null,
    description: null,
    country_id: null,
    language_id: null,
    active: false,
    campaing_type: null,
    capping_end_date: false,
    end_date: null,
    advance_validation: true, // Si debe estar activo de echo en un futuro sera obligatorio
    cost_price: 0,
    delivery_campaign_id: null,
    client_group_id: null,
    automatic_phone_validation_status: false,
    automatic_phone_validation_mode: null,
    autocomplete_geolocation_status: false,
}